import { Controller } from "@hotwired/stimulus";

/**
 * Handles customer selection in compose forms
 * Auto-fills email/phone and name fields when a customer is selected
 */
export default class extends Controller {
  static targets = ["customerSelect", "email", "phone", "name"];

  customerSelected(event) {
    const select = event.target;
    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption || !selectedOption.value) {
      // "New recipient" selected - clear fields for manual entry
      this.clearFields();
      return;
    }

    // Auto-fill fields from selected customer data
    const email = selectedOption.dataset.email;
    const phone = selectedOption.dataset.phone;
    const name = selectedOption.dataset.name;

    if (this.hasEmailTarget && email) {
      this.emailTarget.value = email;
    }

    if (this.hasPhoneTarget && phone) {
      this.phoneTarget.value = phone;
    }

    if (this.hasNameTarget && name) {
      this.nameTarget.value = name;
    }
  }

  clearFields() {
    if (this.hasEmailTarget) {
      this.emailTarget.value = "";
    }
    if (this.hasPhoneTarget) {
      this.phoneTarget.value = "";
    }
    if (this.hasNameTarget) {
      this.nameTarget.value = "";
    }
  }
}
